import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { API_BASE_URL } from '@/lib/config';
import { ReportHistory } from '@/pages/ReportHistory';

interface ReportHistoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** API base runtime của S3 Explorer khi nhúng vào frontend host. Mặc định `API_BASE_URL`. */
  apiBaseUrl?: string;
}

/**
 * Modal "Lịch sử tạo báo cáo" dùng cho bản nhúng package vào frontend host.
 *
 * Package chỉ export component `S3Explorer` (không kèm router), nên route `/report-history`
 * của app standalone không tồn tại trên frontend host. Mở lịch sử dưới dạng modal ngay
 * trong `S3Explorer` để không phụ thuộc router của host.
 */
export function ReportHistoryModal({
  open,
  onOpenChange,
  apiBaseUrl = API_BASE_URL,
}: ReportHistoryModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] w-[96vw] max-w-[1400px] overflow-hidden p-0">
        <DialogTitle className="sr-only">Lịch sử tạo báo cáo</DialogTitle>
        <DialogDescription className="sr-only">
          Theo dõi các lần tạo báo cáo Ban lãnh đạo, trạng thái gửi Teams và chạy test nhanh.
        </DialogDescription>
        <div className="max-h-[92vh] overflow-y-auto">
          <ReportHistory layout="embedded" apiBaseUrl={apiBaseUrl} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
